import {
  updateDoc,
  getFirestore,
  doc,
  getDoc,
  collection,
  getDocs,
  query,
  where,
  arrayRemove,
  arrayUnion
} from "firebase/firestore";
import { app } from "../../credenciales";

const db = getFirestore(app);

export const getUserData = async (userEmail) => {
  try {
    const docRef = doc(db, "usuarios", userEmail);
    const docSnap = await getDoc(docRef);
    const data = docSnap.data();
    return data;
  } catch (error) {
    console.log(error);
  }
}

export const updateUser = async (userEmail, newUserData) => {
  try {
    await updateDoc(doc(db, "usuarios", userEmail), newUserData);
  } catch (error) {
    console.log(error);
  }
}

export const getUserByEmail = async (email) => {
  const q = query(
    collection(db, "usuarios"),
    where("email", "==", email)
  );
  const querySnapshot = await getDocs(q);
  return querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

export const getUsersByDate = async (idActividad, fecha) => {
  let activityName;
  let usersDetails;

  try {
    const actividadRef = doc(db, 'actividades', idActividad);
    const actividadDoc = await getDoc(actividadRef);

    if (actividadDoc.exists()) {
      const actividadData = actividadDoc.data();
      const fechas = actividadData.fechas;
      const nombreActividad = actividadData.nombre;

      activityName = nombreActividad;

      // Buscar la fecha específica en el array de fechas
      const fechaRegistrada = fechas.find(f => f.fecha === fecha);

      if (fechaRegistrada) {
        const usuariosDetalles = await Promise.all(
          fechaRegistrada.usuarios.map(async (usuario) => {
            const userData = await getUserByEmail(usuario.id);
            return {
              email: userData[0].email,
              name: userData[0].name,
              lastName: userData[0].lastName,
              present: usuario.presente,
              ausenteConAviso: usuario.ausenteConAviso || false,
            };
          })
        );
        usersDetails = usuariosDetalles;
      } else {
        console.log('No hay registros para esta fecha');
      }
    } else {
      console.log('No se encontró la actividad');
    }
  } catch (error) {
    console.error('Error al obtener los datos: ', error);
  }
  return { usersDetails, activityName }
}

export const toggleAusenteConAviso = async (userId, activar, fecha, idActividad) => {
  try {
    const actividadRef = doc(db, 'actividades', idActividad);
    const actividadDoc = await getDoc(actividadRef);

    if (actividadDoc.exists()) {
      const data = actividadDoc.data();
      const fechas = data.fechas;

      const indexFecha = fechas.findIndex(f => f.fecha === fecha);
      if (indexFecha !== -1) {
        const usuarios = fechas[indexFecha].usuarios;
        const indexUsuario = usuarios.findIndex(u => u.id === userId);

        if (indexUsuario !== -1) {
          usuarios[indexUsuario].presente = false;
          usuarios[indexUsuario].ausenteConAviso = activar;

          fechas[indexFecha].usuarios = usuarios;
          await updateDoc(actividadRef, { fechas });
        }
      }
    }
  } catch (error) {

  }
}

export const getUsers = async () => {
  try {
    const usuariosCollection = collection(db, "usuarios");
    const usuariosSnapshot = await getDocs(usuariosCollection);
    return usuariosSnapshot;
  } catch (error) {
    console.log(error);
  }
}

export const getUsersByActivity = async (id) => {
  try {
    const qUsers = query(collection(db, "usuarios"), where("actividades", "array-contains", id));
    const usersInActivity = await getDocs(qUsers);
    return usersInActivity;
  } catch (error) {
    console.log(error);
  }
}

export const updateUserActivity = async (userId, activityId, action) => {
  try {
    const userRef = doc(db, "usuarios", userId);
    if (action === 'add') {
      await updateDoc(userRef, { actividades: arrayUnion(activityId) });
    } else {
      await updateDoc(userRef, { actividades: arrayRemove(activityId) });
    }
  } catch (error) {

  }
}